export default "__VITE_ASSET__BkQPl73e__"